module.exports = __webpack_public_path__ + "img/donation-prep-6.e8d28f1e.png";